import { deepMenu, FocusWithin, State } from './Component/Menu';

FocusWithin(document);

// apperantly we have never needed this
// new State({
//     header: '#deep-nav',
//     namespace: 'deep-nav'
// });

new deepMenu({
    namespace: 'deep-nav',
    header: 'fixed-header',
    hamburger: 'header__hamburger'
});
